import { Button, List, ListItem } from "@mui/material";
import { Fragment } from "react";
import colors from "../../../../theme/themeConstants";
import { IReason } from "./ReportPopup";

interface IProps {
  reportReasons: IReason[];
  reportReason: IReason;
  setReportReason: (reason: IReason) => void;
  nextStep: () => void;
}

const ReportStepOne = (props: IProps) => {
  const { reportReasons, reportReason, setReportReason, nextStep } = props;

  const isSelected = (value: number, selected: IReason) => {
    if (value === selected.value) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <Fragment>
      <b style={{ margin: "18px 0", fontWeight: 500 }}>Why are you reporting this GIF?</b>
      <List
        sx={{
          width: "100%",
          margin: "0",
          padding: "0",
          color: "black !important",
          "& p": {
            fontSize: "14px"
          },
        }}
      >
        {reportReasons.map(el => (
          <ListItem
            key={el.value}
            onClick={() => setReportReason(el)}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "15px",
              cursor: "pointer",
              backgroundColor: isSelected(el.value, reportReason) ? "var(--light-bg)" : "transparent",
              borderRadius: "16px",
              ".selectedIcon": {
                width: "12px",
                height: "12px",
                backgroundColor: "var(--red-accent)",
                borderRadius: "50%",
                transition: "opacity .3s ease",
                opacity: isSelected(el.value, reportReason) ? "1" : "0",
              }
            }}>
            <p>{el.text}</p>
            <div className="selectedIcon"></div>
          </ListItem>
        ))}
      </List>
      <Button variant="contained" fullWidth sx={{
        background: colors.purpleGradient,
        margin: "2rem 0 2rem 0",
        minHeight: "3rem",
        fontSize: "16px",
        fontWeight: "500",
        borderRadius: "38px",
        boxShadow: "inherit",
        fontFamily: "'Poppins', sans-serif",
        "&:hover": {
          boxShadow: "inherit"
        }
      }} onClick={nextStep}>
        Next
      </Button>
    </Fragment>
  );
};

export default ReportStepOne;
